module.exports = __webpack_public_path__ + "img/plus_btn.794eda4c.png";